import { formatDate, formatDateTime, formatDateFull, formatDateTimeFull } from "@/lib/utils";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "@/components/ui/tooltip";

interface DateCellProps {
  value: string | Date | null | undefined;
  className?: string;
  includeTime?: boolean;
  fallback?: string;
  "data-testid"?: string;
}

export function DateCell({ value, className, includeTime, fallback = "-", "data-testid": testId }: DateCellProps) {
  const short = includeTime ? formatDateTime(value) : formatDate(value);
  const full = includeTime ? formatDateTimeFull(value) : formatDateFull(value);

  if (short === "-") {
    return <span className={className} data-testid={testId}>{fallback}</span>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={className} data-testid={testId}>{short}</span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{full}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
